/**
 * HEADER
 */
export const headerActionTypes = {
  SET_ITEM_TOOLBAR_DISPLAY: "SET_ITEM_TOOLBAR_DISPLAY",
  SET_SEARCH_BAR_DISPLAY: "SET_SEARCH_BAR_DISPLAY",
  TOGGLE_HEADER_CLICK: "TOGGLE_HEADER_CLICK",
};
